import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import LoginForm from './components/LoginForm';
import Header from './components/Header';
import ProtectedRoute from './utils/ProtectedRoute/ProtectedRoute';
import Home from './containers/Home/Home';
import theme from './theme';

// Use empty string as default for development
const basename = process.env.PUBLIC_URL || '';

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <BrowserRouter basename={basename}>
                {/* The shell is a column that fills the viewport: a fixed-height
                    header and a scrollable main. `minHeight: 100dvh` (not 100vh)
                    so mobile browsers' collapsing address bar doesn't leave a
                    dead strip at the bottom. */}
                <Box
                    sx={{
                        minHeight: '100dvh',
                        display: 'flex',
                        flexDirection: 'column',
                        bgcolor: 'background.default',
                    }}
                >
                    <Header />
                    <Box component='main' sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                        <Routes>
                            <Route
                                path='/'
                                element={
                                    <ProtectedRoute>
                                        <Home />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path='/login' element={<LoginForm />} />
                        </Routes>
                    </Box>
                </Box>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
